export const pendingsBoardsColumns = {
  assignedDate: { name: 'assignedDate' },
  assignedUser: { name: 'technician' },
  customer: { name: 'customer' },
  id: { name: 'id' },
  name: { name: 'name' },
  serviceType: { name: 'serviceType' },
  servicePriority: { name: 'priority' },
  status: { name: 'status' },
  serviceTags: { name: 'serviceTags' },
  creationDate: { name: 'creationDate' },
  finalCustomer: { name: 'finalCustomer' },
};
